import { teamRole } from './teamRole';

// we use indexes for priority
export const teamRolesPriority = [teamRole.OWNER, teamRole.MANAGER, teamRole.VIEWER];
